import { useReferralCode } from '@/hooks/useReferralCode';

export function ReferralCapture() {
  useReferralCode();
  return null;
}
